module.exports = __webpack_public_path__ + "static/media/man-mage_1f9d9-200d-2642-fe0f.d5be7d11.png";